export const siteConfig = {
  name: "BlogHub",
  product: "BlogHub Admin",
  description: "Content operations for the BlogHub publication",
  version: "3.0.0",
} as const
